// import React, { useEffect, useState } from "react";
// import { Tooltip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link } from "react-router-dom";
// import PaginationComponent from "../../Components/PaginationComponent";
// import medicineService from "../../Services/medicineService";
// import toast from "react-hot-toast";
// import MedicineDetailsModal from "./MedicineDetailsModal";

// const Medicines = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedMedicine, setSelectedMedicine] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const itemsPerPage = 10;

//   useEffect(() => {
//     const getMedicines = async () => {
//       try {
//         setLoading(true);
//         const response = await medicineService.fetchAll();
//         console.log(response);
//         setPatients(response.medicines);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching Medicines");
//       }
//     };
//     getMedicines();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       patients?.filter((item) =>
//         item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, patients]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleOpenModal = (medicine) => {
//     setSelectedMedicine(medicine);
//     setModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setSelectedMedicine(null);
//     setModalOpen(false);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return ''; // Handle null or undefined
//     const options = { year: 'numeric', month: 'short', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString('en-US', options);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">
//           Medicines Stock
//         </h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%] rounded-xl overflow-hidden">
//             <thead>
//               <tr className="bg-gray-700 text-white text-center text-xs capitalize leading-normal">
//                 <th className="py-4 w-[10%] text-left pl-4">
//                   Sr No.
//                 </th>
//                 <th className="py-4 w-[20%] text-left">
//                   Name
//                 </th>
//                 <th className="py-4 w-[20%]">
//                   Quantity in Stock
//                 </th>
//                 <th className="py-4 w-[10%]">
//                   Price per Unit
//                 </th>
//                 <th className="py-4 w-[10%]">
//                   Action
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((medicine, index) => (
//                 <tr
//                   key={medicine?.id}
//                   className="bg-white text-center text-xs border-t-[1px] border-gray-200"
//                 >
//                   <td className="py-4 w-[10%] text-left pl-4 font-bold">
//                       {index + 1 + (currentPage - 1) * itemsPerPage}.
//                   </td>
//                   <td className="w-[20%] text-left font-bold">
//                       {medicine?.medicine_name}
//                   </td>
//                   <td className="py-[1%] w-[20%]">
//                       {medicine?.quantity_in_stock}
//                   </td>
//                   <td className="w-[10%]">
//                       {medicine?.price}
//                   </td>

//                   <td className="w-[10%]">
//                     <button
//                       className="font-[500] text-blue-500"
//                       onClick={() => handleOpenModal(medicine)}
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>

//       {/* Use the MedicineDetailsModal */}
//       <MedicineDetailsModal
//         open={modalOpen}
//         onClose={handleCloseModal}
//         medicine={selectedMedicine}
//       />
//     </div>
//   );
// };

// export default Medicines;

import React, { useEffect, useState } from "react";
import medicineService from "../../Services/medicineService";
import toast from "react-hot-toast";
import MedicineDetailsModal from "./MedicineDetailsModal";

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const Medicines = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [medicines, setMedicines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const getMedicines = async () => {
      try {
        setLoading(true);
        const response = await medicineService.fetchAll();
        setMedicines(response.medicines);
      } catch (error) {
        toast.error("Error fetching Medicines");
      } finally {
        setLoading(false);
      }
    };
    getMedicines();
  }, []);

  useEffect(() => {
    const result =
      medicines?.filter((item) =>
        item?.medicine_name?.toLowerCase().includes(searchData.toLowerCase()),
      ) || [];
    setFilteredData(result);
  }, [searchData, medicines]);

  const handleOpenModal = (medicine) => {
    setSelectedMedicine(medicine);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedMedicine(null);
    setModalOpen(false);
  };

  const getStockBadge = (qty) => {
    if (qty === null || qty === undefined) return null;
    if (qty === 0)
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-red-100 text-red-600">
          Out of Stock
        </span>
      );
    if (qty <= 10)
      return (
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-yellow-100 text-yellow-700">
          Low — {qty}
        </span>
      );
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-green-100 text-green-700">
        {qty} units
      </span>
    );
  };

  const colWidths = ["70px", "200px", "160px", "130px", "100px"];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      {/* ── Header ── */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Medicines
          </p>
          <p className="text-xs text-gray-400 mt-0.5">
            {filteredData.length || 0} records found
          </p>
        </div>
      </div>

      {/* ── Search ── */}
      <div className="relative mb-4">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
          />
        </svg>
        <input
          type="search"
          placeholder="Search by medicine name..."
          value={searchData}
          onChange={(e) => setSearchData(e.target.value)}
          className="w-full sm:w-72 pl-9 pr-4 py-3 text-xs border border-gray-200 rounded-lg bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-100"
        />
      </div>

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No medicines found
          </div>
        ) : (
          filteredData.map((medicine, index) => (
            <div
              key={medicine?.id}
              className="border border-gray-200 rounded-xl bg-white px-3 py-3"
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0">
                    {medicine?.medicine_name?.charAt(0) || "M"}
                  </div>
                  <div>
                    <p className="text-[12px] font-semibold text-gray-800">
                      {medicine?.medicine_name}
                    </p>
                    <p className="text-[10px] text-gray-400">#{index + 1}</p>
                  </div>
                </div>
                <button
                  className="text-blue-500 font-medium text-[12px] hover:underline"
                  onClick={() => handleOpenModal(medicine)}
                >
                  View
                </button>
              </div>
              <div className="divide-y divide-gray-100">
                <div className="flex justify-between py-1.5">
                  <span className="text-[11px] text-gray-400 w-20">Stock</span>
                  <span className="text-right">
                    {getStockBadge(medicine?.quantity_in_stock)}
                  </span>
                </div>
                <div className="flex justify-between py-1.5">
                  <span className="text-[11px] text-gray-400 w-20">Price</span>
                  <span className="text-[11px] text-gray-700">
                    Rs. {medicine?.price}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Sr No.",
                  "Medicine Name",
                  "Qty in Stock",
                  "Price / Unit",
                  "Action",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${
                      i < 4 ? "border-r border-white/10" : ""
                    }`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={5}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No medicines found
                  </td>
                </tr>
              ) : (
                filteredData.map((medicine, index) => (
                  <tr
                    key={medicine?.id}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${
                      index % 2 ? "bg-gray-50" : "bg-white"
                    }`}
                  >
                    <td className="px-4 py-2.5 text-[12px] font-semibold text-gray-500 border-r border-gray-100">
                      {index + 1}
                    </td>
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <div className="flex items-center gap-2">
                        {/* <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-semibold text-gray-600 uppercase flex-shrink-0">
                          {medicine?.medicine_name?.charAt(0) || "M"}
                        </div> */}
                        <span className="text-[12px] font-medium text-gray-800 truncate">
                          {medicine?.medicine_name}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] border-r border-gray-100">
                      {getStockBadge(medicine?.quantity_in_stock)}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      Rs. {medicine?.price}
                    </td>
                    <td className="px-4 py-2.5 text-[12px]">
                      <button
                        className="text-[11px] font-medium text-white bg-[#2F6DB4] px-2.5 py-1 rounded-lg hover:bg-[#255A8C] transition"
                        onClick={() => handleOpenModal(medicine)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={5}
                  className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium text-gray-100 border-t border-white/10"
                >
                  {filteredData?.length || 0} total records
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <MedicineDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        medicine={selectedMedicine}
      />
    </div>
  );
};

export default Medicines;
